import React from 'react';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';
import ClearIcon from '@mui/icons-material/Clear';
import DoneIcon from '@mui/icons-material/Done';
import './indicadorEstado.scss';


export const IndicadorEstado = ({ type, onClick, showIcon = true }) => {

    return (
        <div aria-hidden='true' onClick={onClick} className={`indicador ${!!onClick ? 'clickeable' : ''}`}>
            <div className={`indicador-circle ${type}`}>
                {showIcon && icon[type]}
            </div>
        </div>
    )
}

const icon = {
    'success': <DoneIcon />,
    'warning': <PriorityHighRoundedIcon />,
    'error': <ClearIcon />
}